<template>
  <div class="RunReport">
    <v-container>
      <h2>{{ report.Name }}</h2>
      <p>{{ report.Description }}</p>
      <v-form>
        <div v-for="item in report.Filters" :key="item.FilterId">
          <v-select
            v-if="item.FilterType == 'LookupList'"
            :label="getLabel(item)"
            item-value="Reference"
            item-text="ShortName"
            :items="item.items"
            v-model="item.Value"
          ></v-select>

          <div v-else-if="item.FilterType == 'Parameter'"> 
            <DatePicker
            v-if="item.FieldType == 'datetime'"
            :label="getLabel(item)"
            v-model="item.Value"
          ></DatePicker>
          <v-text-field
            v-else
            :label="getLabel(item)"
            v-model="item.Value"
          ></v-text-field>
          </div>
          
        </div>
        <div class="reportButtons">
          <v-btn @click="getInputs" color="primary">Run Report</v-btn>
          <v-btn :disabled="!hasReportData" @click.prevent="exportReport">Export Results</v-btn>
          <v-btn :disabled="!hasReportData" @click="mergeReport">Merge</v-btn>
          <v-btn @click="getReportSource">Source</v-btn>
        </div>
      </v-form>
      <div v-if="reportSource != ''" class="source">
        <p>{{ reportSource }}</p>
      </div>
      <v-data-table
        dense
        :items="reportData"
        :headers="reportHeaders"
        :items-per-page="15"
        :loading="loadingReport"
        loading-text="Loading... Please wait"
      >
      </v-data-table>
      <v-dialog v-model="showQuote" max-width="700" persistent>
        <Letters
          @closeQuote="showQuote = false"
          :reportKey="reportKey"
          :reportId="report.ReportId"
        />
      </v-dialog>
      <v-dialog v-model="showCalculation" max-width="500" persistent>
        <Calculation
          :formName="report.InputForm"
          :currentPlanId="currentPlanId"
          @calculateClick="onLoadInputs"
          returnInputs="true"
        />
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import Letters from '../Members/Leavers/Letters.vue';
import Calculation from '../Members/Leavers/Calculation.vue';
import DatePicker from '@/components/formControls/DatePicker.vue';

export default {
  name: 'RunReport',
  components: {
    Letters,
    Calculation,
    DatePicker,
  },
  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
  },
  mounted: function () {
    this.getReport();
  },
  data: () => ({
    reportInputs: [],
    report: null,
    lookupList: [],
    reportData: [],
    reportHeaders: [],
    hasReportData: false,
    reportKey: '',
    checkingStatus: false,
    loadingReport: false,
    showSQL: false,
    reportSource: '',

    showQuote: false,
    selectedMemberId: 0,
    calculationResult: [],
    showCalculation: false,
  }),
  methods: {
    onLoadInputs(val, data) {
      this.showCalculation = false;
      if (val == 'calculate') {
        console.log(data);
        this.runReport(data);
      }
      console.log(data);
    },
    async getReportSource() {
      try {
        let response = await this.$api.get(
          '/Report/GetReportSource?reportId=' + this.$route.query.id
        );
        this.reportSource = response.data;
      } catch (err) {
        console.log(err);
      }
    },
    async getInputs() {
      if (this.report.InputForm != null && this.report.InputForm != '') {
        this.showCalculation = true;
      } else {
        this.runReport();
      }
    },
    async runReport(inputItems) {
      try {
        var items = [];
        this.reportHeaders = [];
        this.report.Filters.forEach((item) => {
          items.push({
            FilterId: item.FilterId,
            tableName: item.tableName,
            field: item.field,
            Value: item.Value,
          });
        });
        var data = {
          planId: this.currentPlanId,
          reportId: this.$route.query.id,
          filters: items,
          inputs: inputItems,
        };
        let response = await this.$api.post('/Report/RunReport', data);
        this.reportKey = response.data;
        this.timer = setInterval(this.checkReportStatus, 5000);
        this.loadingReport = true;
      } catch (err) {
        console.error(err);
      }
    },

    async checkReportStatus() {
      try {
        if (this.checkingStatus) return;
        this.checkingStatus = true;
        let response = await this.$api.get('/Report/CheckReportStatus?reportKey=' + this.reportKey);
        console.log(response.data);
        var status = response.data;
        if (status == 'Completed') {
          clearInterval(this.timer);
          let response = await this.$api.get(
            '/Report/GetReportResults?reportKey=' + this.reportKey
          );

          var s = JSON.parse(response.data);
          var headers = Object.keys(s.Rows[0]);
          headers.forEach((element) => {
            this.reportHeaders.push({ text: element, value: element });
          });

          this.reportData = s.Rows;
          if (this.reportData.length > 0) this.hasReportData = true;
          this.loadingReport = false;
        } else {
          this.checkingStatus = false;
        }
      } catch (err) {
        this.loadingReport = false;
        clearInterval(this.timer);
        console.error(err);
      }
    },
    getLabel(item) {
      let label = item.Prompt == '' ? item.Heading : item.Prompt;
      return label + ` (${item.Condition})`;
    },
    async getReport() {
      try {
        var reportId = this.$route.query.id;
        let response = await this.$api.get('/Report/GetReportById?id=' + reportId);
        this.report = response.data;
        for (let element of this.report.Filters) {
          let [tableName, fieldName] = element.FieldName.split('.');
          let label = this.report.Details.find(f => f.FieldName == fieldName && f.Tablename == tableName);
          if (label){
            element.Heading = label.Heading;
          } else {
            element.Heading = element.FieldName
          }
          
          if (element.FilterType == 'LookupList') {
            this.$set(element, 'items', await this.getLookupItems(element));
            //element.items = await this.getLookupItems(element);
            //this.lookupList=element.items;
            console.log(element.items);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getLookupItems(item) {
      try {
        let response = await this.$api.get(
          '/Report/GetReportLookupList?planid=' +
            this.currentPlanId +
            '&listType=' +
            item.FieldName +
            '&filter=' +
            item.Filter
        );
        return response.data;
      } catch (err) {
        console.error(err);
      }
    },
    async exportReport() {
      try {
        const response = await this.$api.get(
          '/Report/exportreportdata?reportKey=' +
            this.reportKey +
            '&reportId=' +
            this.report.ReportId,
          { responseType: 'blob' }
        );
        const blob = new Blob([response.data], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        var selectedFile = this.report.Name + ' Report.csv';
        link.setAttribute('download', selectedFile);
        document.body.appendChild(link);
        link.click();

        URL.revokeObjectURL(link.href);
      } catch (err) {
        console.error(err);
      }
    },
    async mergeReport() {
      this.showQuote = true;
    },
  },
};
</script>
<style lang="scss">
.reportButtons button {
  margin-right: 20px;
}
.source {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>

<style lang="scss"></style>
